import Text from 'components/3catinfo/Text';
import styles from '../cosminutaminut.module.scss';

const Cites = (props) => {
    let { text } = props;
    text = text.replaceAll('"', '');
    text = text.replaceAll('&quot;', '');
    return <Text text={text} dataTestId='cos-noticia-cita' className={styles.cita} />;
};

export default Cites;
